/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/named */

'use client'

import { Flex } from '@acko-tech/building-blocks.ui.common'
import { useState, useCallback } from 'react'
import svgLoader from '@utils/internalImageLoader'
import parse, { domToReact, attributesToProps } from 'html-react-parser'
import { IconWrap } from '@styles/commonStyles'
import Hyperlink from './Hyperlink'

import {
  FaqAccordianHeader,
  FaqParagraph,
  FaqUnorderedList,
  FaqOrderedList,
  FaqAccordionWrap,
  FaqStyledImage,
  FaqAccordianContent,
  FaqStrongHeading,
  FaqParaHeading,
} from './styles'

const options = {
  replace: domNode => {
    let props

    switch (domNode?.name) {
      case 'p':
        props = attributesToProps(domNode?.attribs)
        return <FaqParagraph>{domToReact(domNode?.children, options)}</FaqParagraph>
      case 'h6':
        props = attributesToProps(domNode?.attribs)
        return <FaqStrongHeading>{domToReact(domNode?.children, options)}</FaqStrongHeading>
      case 'h4':
        props = attributesToProps(domNode?.attribs)
        return <FaqStrongHeading>{domToReact(domNode?.children, options)}</FaqStrongHeading>
      case 'a':
        props = attributesToProps(domNode?.attribs) // Update this
        return <Hyperlink uri={props?.href}>{domToReact(domNode?.children, options)}</Hyperlink>
      case 'ul':
        props = attributesToProps(domNode?.attribs)
        return <FaqUnorderedList>{domToReact(domNode?.children, options)}</FaqUnorderedList>
      case 'ol':
        props = attributesToProps(domNode?.attribs)
        return <FaqOrderedList>{domToReact(domNode?.children, options)}</FaqOrderedList>
    }
  },
}

const Accordion = ({ data, arrowIcon = '' }) => {
  const [active, setActive] = useState(0)

  const handleClick = useCallback(
    index => {
      if (index === active) {
        setActive(-1)
      } else {
        setActive(index)
      }
    },
    [active]
  )

  return (
    <Flex flexDirection="column">
      {data?.collapsibles?.data?.map((collapsible, index) => {
        const collapsibleFields = collapsible?.attributes

        return (
          <FaqAccordionWrap id="accordianwrap" key={collapsibleFields?.title}>
            <FaqAccordianHeader onClick={handleClick.bind(this, index)}>
              <FaqParaHeading colorVal={active === index ? 'rgb(90, 104, 231)' : '#282E33'}>
                {collapsibleFields?.title}
              </FaqParaHeading>
              <IconWrap>
                <FaqStyledImage
                  src={arrowIcon || '/images/arrow-down-grey.svg'}
                  alt="Icon"
                  width="14"
                  height="14"
                  layout="fixed"
                  isopen={(active === index).toString()}
                  loader={svgLoader}
                />
              </IconWrap>
            </FaqAccordianHeader>

            <FaqAccordianContent key={collapsibleFields?.title} show={active === index}>
              {parse(collapsibleFields?.content || '', options)}
            </FaqAccordianContent>
          </FaqAccordionWrap>
        )
      })}
    </Flex>
  )
}

export default Accordion
